import React from "react";
import { Grid, TextField, Button } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";

export default function Search({ value, onChange, onSubmit }) {
  
  const onKeyPress = (e) => {
    if (e.key === "Enter" && value.trim() !== "") {
      onSubmit();
    }
  };
  return (
    <Grid
      container
      justify="flex-start"
      alignItems="center"
      spacing={2}
      style={{ marginBottom: 10 }}
    >
      <Grid item>
        <TextField
          variant="outlined"
          margin="dense"
          placeholder="Nombre"
          value={value}
          onKeyPress={onKeyPress}
          onChange={(e) => onChange(e.target.value)}
        />
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          style={{ height: 40, marginTop: 3 }}
          startIcon={<SearchIcon />}
          onClick={onSubmit}
        >
          Buscar
        </Button>
      </Grid>
    </Grid>
  );
}
